import { ca } from '@cian/analytics';
import { INewbuildingBrokerCallbackWidget } from 'shared/types/newbuildingBrokerCallbackWidget';

import { getNewbuildingBrokerGaLabel, getNewbuildingBrokerProducts } from '../utils';

export const trackCallbackWidgetOpen = (offerInfo: INewbuildingBrokerCallbackWidget['offerInfo']) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Booking_click_label',
    category: 'Listing',
    label: getNewbuildingBrokerGaLabel(offerInfo),
    products: getNewbuildingBrokerProducts(offerInfo),
    page: {
      extra: {
        listing_label: true,
      },
    },
  });
};
